// extracted by mini-css-extract-plugin
export var active = "_2y-7";
export var backButton = "_2y-6";
export var clone = "_2y-c";
export var collapseBar = "_2y-h";
export var collapseMode = "_2y-j";
export var dragHandle = "_2y-a";
export var dropdownIcon = "_2y-e";
export var hidden = "_2y-p";
export var iconContainer = "_2y-m";
export var iconSwapper = "_2y-o";
export var navItem = "_2y-4";
export var navItemIcon = "_2y-d";
export var navProfile = "_2y-5";
export var notificationCountBadge = "_2y-g";
export var notificationDot = "_2y-n";
export var optionsContainer = "_2y-f";
export var primaryNav = "_2y-0";
export var primaryTab = "_2y-k";
export var secondaryNav = "_2y-1";
export var selected = "_2y-l";
export var settingsNav = "_2y-2";
export var settingsNavItems = "_2y-3";
export var show = "_2y-b";
export var sideNav = "_2y-i";
export var teamItem = "_2y-8";
export var userProfileItem = "_2y-9";